<script lang="ts">
export default {
  name: 'KkBoxWithMenu',
}
</script>

<script lang="ts" setup>
import { ref } from 'vue'
import { KkIcon } from '../'

export type MenuItem = {
  type: string
  text: string
}

export interface Props {
  menuList: MenuItem[]
}

export interface Emits {
  (key: 'on-click-edit-menu', value: MenuItem['type']): void
}

const props = defineProps<Props>()
const emits = defineEmits<Emits>()
const showEditMenu = ref(false)

const handleEditMenu = (type: MenuItem['type']) => {
  emits('on-click-edit-menu', type)
  closeDropdown()
}

const closeDropdown = () => {
  showEditMenu.value = false
}
</script>

<template>
  <div class="box">
    <div class="box__header">
      <div class="box__title">
        <slot name="title" />
      </div>
      <div class="menu__editButton">
        <button type="button" @click="showEditMenu = !showEditMenu">
          <KkIcon name="verticalThreePointLeader" />
        </button>
        <ul v-show="showEditMenu" class="menu__editList">
          <li v-for="menu in props.menuList"
              :key="menu.type"
              class="menu__editListItem"
              @click="handleEditMenu(menu.type)"
          >
            {{ menu.text }}
          </li>
        </ul>
      </div>
    </div>
    <div>
      <slot />
    </div>
    <div v-if="showEditMenu" class="bg" @click="closeDropdown" />
  </div>
</template>

<style lang="scss" scoped>
.box {
  padding: 24px;
  border: 1px solid #E4E7EB;
  border-radius: 4px;
  &__header {
    display: flex;
    justify-content: space-between;
  }
  &__title {
    width: 100%;
    margin-bottom: 16px;
    font-weight: bold;
    font-size: 18px;
  }
}
.menu {
  &__editButton {
    display: flex;
    position: relative;
    cursor: pointer;
  }
  &__editList {
    position: absolute;
    right: 0;
    z-index: 1;
    width: 240px;
    padding: 10px 0;
    box-shadow: 0 1px 4px rgb(0 0 0 / 26%);
    background: white;
  }
  &__editListItem {
    margin-bottom: 5px;
    padding: 20px 24px;
    &:hover {
      background-color: rgba(0, 0, 0, .1);
      cursor: pointer;
    }
  }
}
.bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
